import './form-input.css';
import React from 'react';

function FormField({
    onChange,
    data = {},
    onBlur,
    name,
    value,
    error,
    bg,
    required = false,
    disabled = false,
    readOnly = false,
    maxLength = 50,
    PointMaxValue,
    className = `${bg ? 'credentials_box' : "box"}`,
    mTop = "mt-2",
    masking = null,
    error_Height,
    onKeyDown
}) {



    const handleInput = (e) => {
        let inputValue = e.target.value;

        // Allow only numbers and one decimal point

        // Ensure only one decimal point
        if (inputValue.split('.').length > 2) {
            inputValue = inputValue.replace(/[^0-9.]/g, ''); // Removes non-numeric characters except the decimal point
            inputValue = inputValue.replace(/\.+$/, ''); // Remove extra decimal points
        }


        // Apply masking if provided
        if (masking?.enabled && masking?.formatFunction) {
            inputValue = masking.formatFunction(inputValue);
        }

        // Set max length or value for non-description fields
        if (name !== 'description') {
            let maxValue = maxLength;
            if (PointMaxValue && inputValue.includes('.')) {
                maxValue = PointMaxValue;
            }
            e.target.maxLength = maxValue;
            if (inputValue.length > maxValue) {
                inputValue = inputValue.slice(0, maxValue);
            }
        }

        e.target.value = inputValue;
        onChange(e); // Call onChange to update parent state
    };

    return (
        <>
            <div >
                {
                    data?.label && <label className={'fw-6 font-11 black-color   p-0 text-nowrap'}>{data.label} {required && <span className="text-danger">*</span>}</label>
                }
                <div className={`form-group ${className}`}>
                    <div className="form-prefix px-0">
                        {data.leftIcon && <div className="form-prefix px-0">{data.leftIcon}</div>}
                    </div>
                    <div className="form-control-wapper">
                        <input
                            readOnly={readOnly}
                            name={name}
                            disabled={disabled}
                            onKeyDown={onKeyDown}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            type={data?.type ? data?.type : 'text'}
                            className="custom-form-control font-11 "
                            placeholder={data.placeholder || ''}
                            maxLength={maxLength}
                        // onInput={(e) => {
                        // const { type } = data || {};
                        // const value = e.target.value;
                        // const effectiveMaxLength = (type === "number" && value.includes(".")) ? PointMaxValue : e.target.maxLength;
                        // e.target.maxLength = effectiveMaxLength;
                        // if (type === "number") {
                        //     const regex = /^\d*\.?\d{0,2}$/;
                        //     if (value.length > effectiveMaxLength) {
                        //         e.target.value = value.slice(0, effectiveMaxLength);
                        //     }
                        //     if (!regex.test(value)) {
                        //         e.target.value = value.slice(0, -1);
                        //     }
                        // }
                        // }}
                        />
                    </div>
                    {data.rightIcon && <div className="form-append">{data.rightIcon}</div>}
                </div>
            </div>
            {
                error_Height ?
                    <div className='font-11 error_Height red-color'>{error && error}</div> : error && <div className='font-11 mt-1 red-color'>{error}</div>
            }
        </>
    );
}

export default FormField;

